import { connect } from 'react-redux';
import { isLoading } from 'helpers';
import {
  loadGlobalCisForecastsAttributesCreator,
  loadMaCisCreator,
  removeMaCisCreator,
  removeMaCisFiltersCreator,
  setMaCisFiltersCreator,
  setMaCisPageCreator,
  setMaCisPerPageCreator,
  setMaCisProfileCreator,
  setMaCisSortCreator,
} from '../../../../store/actionsCreators';
import Forecasts from '../../../../shared/Cis/Forecasts/Forecasts';

const mapStateToProps = ({ loading, ma, globals, user }) => ({
  loading: isLoading(loading, 'LOAD_MA_CIS'),
  type: 'ma',
  list: ma.cis.forecasts,
  levelDomains: globals.cis.levelDomains,
  levelDomainsLevels: globals.cis.levelDomainsLevels,
  userPermissions: user.userPermissions,
  levelDomainsDomains: globals.cis.levelDomainsDomains,
});

const mapDispatchToProps = (dispatch) => ({
  loadList: () => dispatch(loadMaCisCreator('forecasts')),
  setPage: (payload) => dispatch(setMaCisPageCreator('forecasts', payload)),
  setPerPage: (payload) => dispatch(setMaCisPerPageCreator('forecasts', payload)),
  setSort: (payload) => dispatch(setMaCisSortCreator('forecasts', payload)),
  setFilters: (payload) => dispatch(setMaCisFiltersCreator('forecasts', payload)),
  removeFilters: () => dispatch(removeMaCisFiltersCreator('forecasts')),
  setProfile: (payload) => dispatch(setMaCisProfileCreator('forecasts', payload)),
  removeForecast: (payload) => dispatch(removeMaCisCreator('forecasts', payload)),
  loadForecastsAttributes: () => dispatch(loadGlobalCisForecastsAttributesCreator()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Forecasts);
